<template>
    <div>
        <modal :name="modal_name" class="" transition="nice-modal-fade">
            <div class="v-modal-content" style="border-radius: 15px;background-color: #f2f3f5 !important;height:460px">
                <div class="v-modal-header align-items-center" style="background-color: #bccce0 !important;">
                    <span class="fs-14 fw-600 text-black" style="text-transform:none !important;">Share Report</span>
                </div>
                <div class="general-section pl-0 pr-0 pb-1" style="background-color: #f2f3f5;border-radius:0px">
                    <div class="v-modal-body pt-5 pb-0" style="height:300px;max-height: 460px;overflow-x: hidden;overflow-y: auto;">
                        <div class="multi-input mt-4">
                            <label class="inputLabel fs-14 fw-600 text-black">To<span class="text-danger pl-1">*</span></label>
                            <vue-tags-input v-model="toemail" class="mt-2 custom-tag" v-validate="'email'" placeholder="Enter email id here" name="toemails" id='toemails' :tags="toemails" @tags-changed="newToEmails => toemails = newToEmails" />
                            <span class="text-danger" v-show="errors.has('toemails')">{{ errors.first("toemails") }}</span>
                        </div>
                        <div class="multi-input mt-4">
                            <label class="inputLabel fs-14 fw-600 text-black">Cc</label>
                            <vue-tags-input v-model="cc" class="mt-2" v-validate="'email'" placeholder="Enter email id here" name="ccs" id='ccs' :tags="ccs" @tags-changed="newCcs => ccs = newCcs" />
                            <span class="text-danger" v-show="errors.has('ccs')">{{ errors.first("ccs") }}</span>
                        </div>
                        <div class="multi-input mt-4">
                            <label class="inputLabel fs-14 fw-600 text-black">Bcc</label>
                            <vue-tags-input v-model="bcc" v-validate="'email'" class="mt-2" placeholder="Enter email id here" name="bccs" id='bccs' :tags="bccs" @tags-changed="newBccs => bccs = newBccs" />
                            <span class="text-danger" v-show="errors.has('bccs')">{{ errors.first("bccs") }}</span>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center my-8" >
                    <button style="text-transform: capitalize;" class="btn text-white btn-width btn-danger-new" @click="cancel">
                        Cancel
                    </button>
                    <button style="text-transform: capitalize;" :disabled="is_sent" class="btn btn-success text-white btn-width ml-5" @click="sendReport">
                        Send Report
                    </button>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";
import { SweetModal } from 'sweet-modal-vue';
import report from '../mixins/report';
export default {
    props:['modal_name', 'showDetails'],
    mixins: [report],
    components: {
        VueTagsInput,
        SweetModal
    },
    data() {
        return {
            success_msg:'',
            warning_msg:'',
            toemails: [],
            toemail: '',
            ccs: [],
            cc: '',
            bccs: [],
            bcc: '',
            is_sent: false
        }
    },
    methods: {
        cancel() {
            setTimeout(() => {
                this.$modal.hide(this.modal_name);
            }, 500);
            this.$emit('hideGenerateReport');
        },
        sendReport() {
            this.$validator.validateAll().then(result => {
                if (result == true && this.create_json.to_email.length !== 0){
                    this.create_json.cc_list.forEach((cc, index) => {
                        this.create_json.cc_list[index] = cc.text;
                        delete cc.text
                        delete cc.tiClasses
                    });
                    this.create_json.bcc_list.forEach((bcc, index) => {
                        this.create_json.bcc_list[index] = bcc.text;
                        delete bcc.text
                        delete bcc.tiClasses
                    });
                    this.create_json.to_email.forEach((email, index) => {
                        this.create_json.to_email[index] = email.text;
                        delete email.text
                        delete email.tiClasses
                    });
                    this.saveReport(this.create_json);
                }
                else {
                    this.$toasted.global.error("Please Fill All The Required Fields")
                }
            })
        },
        async saveReport(params) {
            this.is_sent = true;
            try {
                let param = params;
                let response = await this.generateIndividualReport(param);
                this.success_msg = response.response.success_message;
                setTimeout(() => {
                    this.$refs.success_modal.open();
                }, 1000);
                setTimeout(() => {
                    this.cancel();
                    this.$refs.success_modal.close();
                    this.is_sent = false;
                }, 3000);
            }
            catch(reason) {
                this.is_sent = false;
                this.warning_msg = reason;
                setTimeout(() => {
                    this.$refs.warning_modal.open();
                }, 1000);
            }
        }
    },
    mounted() {
    },
    computed: {
        create_json() {
            return {
                bcc_list: this.bccs,
                cc_list: this.ccs,
                ticket_id: this.showDetails.ticket_id,
                to_email: this.toemails
            }
        }
    },
    created(){
        const dict = {
            custom: {
                toemails:{
                    email:() => "Enter valid Email Id",
                },
                ccs:{
                    email:() => "Enter valid Email Id",
                },
                bccs:{
                    email:() => "Enter valid Email Id",
                },
            }
        }
        this.$validator.localize("en", dict); 
    }
}
</script>

<style scoped>
    
</style>